import React from 'react'
import { Stack } from '@mui/material'
import { useOutlet } from 'react-router-dom'

import { B2CFilters } from './components/b2c-filters.tsx'
import { B2CActionButtons } from './components/b2c-action-buttons.tsx'
import { B2CRequestTable } from './table'

export const B2CPage = (): React.ReactElement => {
  const outlet = useOutlet()
  if (outlet) return outlet

  return (
    <Stack gap={3}>
      <B2CActionButtons />
      <B2CFilters />
      <B2CRequestTable />
    </Stack>
  )
}
